import { GetUnreadCountCase } from './domain/useCases/GetUnreadCountCase'
import { ReduceUnreadCountCase } from './domain/useCases/ReduceUnreadCountCase'
import { UnreadCountDatasource } from './external/UnreadCountDatasource'
import { unreadCountRepository } from './infra/repositories/UnreadCountRepository'

const getUnreadCount = GetUnreadCountCase(
  unreadCountRepository(UnreadCountDatasource)
)

const reduceUnreadCount = ReduceUnreadCountCase(
  unreadCountRepository(UnreadCountDatasource)
)

export const unreadCountInstance = {
  getUnreadCount,
  reduceUnreadCount
}
